<template>
  <div class="view-leads inspection-collapse">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      >
      </vs-button>
      <div class="pr-4 justify-right">
        <h2 class="pl-2">{{ $t("labels.inspection") }}</h2>
      </div>
      <feather-icon
        :title="$t('labels.refresh')"
        icon="RefreshCwIcon"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        @click.prevent="getProject()"
      ></feather-icon>
    </div>
    <div class="inspect-question">
      <div>
        <view-project :project="project"></view-project>
      </div>
      <vx-card :title="$t('labels.select_consultant_service')" v-if="false">
        <div class="vx-row w-full m-0 mb-2">
          <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-4">
            <label class>{{ $t("labels.consultant") }}</label>
            <v-select
              v-model="consultant"
              :options="consultants"
              :reduce="(consultants) => consultants.id"
              :value="$store.myValue"
              @input="setSelectedCon"
              label="name"
              name="consultants"
            />
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0 sm: p-0 md:pl-4"
          >
            <label class>{{ $t("labels.service") }}</label>
            <v-select
              v-model="service"
              :options="services_drop"
              :reduce="(services_drop) => services_drop.id"
              label="name"
              name="service"
              :value="$store.myValue"
              @input="setSelectedSer"
            />
          </div>
        </div>
      </vx-card>
      <div class="vx-row w-full mx-0" v-if="service && false">
        <div class="vx-col sm: w-full mt-6">
          <div class="vx-row mb-6">
            <div
              class="vx-col sm: w-full md:w-full label-center p-0 question-card"
            >
              <fullscreen
                ref="fullscreenExecutive"
                @change="fullscreenChangeExecutive"
              >
                <vx-card
                  :title="$t('labels.executive_summary')"
                  class="mb-6 sub-cards user-listing"
                  v-if="
                    (selected_ser === 1 ||
                      selected_ser === 2 ||
                      selected_ser === 4) &&
                    executive_summary_data &&
                    renderComponent
                  "
                >
                  <div class="component-button-right">
                    <vs-button
                      class="float-right btn-add user-add-btn min-max-toggle"
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenExecutive ? 'icon-minimize' : 'icon-maximize'
                      "
                      @click="toggle('executive')"
                    ></vs-button>
                  </div>
                  <div v-if="change_component">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                        class="component-button-right"
                      >
                        <executive-summary
                          :fullscreen-executive="fullscreenExecutive"
                          :executive-data="executive_summary_data"
                          :project-id="this.$route.params.id"
                          :consultant-id="selected_con"
                          :service-id="selected_ser"
                          @updated="updateTheValue"
                        >
                        </executive-summary>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                  <div v-if="!change_component">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                        class="component-button-right"
                      >
                        <executive-summary-max
                          :executive-data="executive_summary_data"
                          :project-id="this.$route.params.id"
                          :consultant-id="selected_con"
                          :service-id="selected_ser"
                          @updated="updateTheValue"
                        >
                        </executive-summary-max>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenVessel"
                @change="fullscreenChangeVessel"
              >
                <vx-card
                  :title="$t('labels.vessel_assessment')"
                  class="mb-6 sub-cards user-listing"
                  v-if="selected_ser === 1"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="
                        fullscreenVessel ? 'icon-minimize' : 'icon-maximize'
                      "
                      @click="toggle('vessel')"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <vessel-assessment
                        :consultant-id="selected_con"
                      ></vessel-assessment>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenGeneralInfo"
                @change="fullscreenChangeGeneralInfo"
              >
                <vx-card
                  :title="$t('labels.general_information')"
                  class="mb-6 sub-cards user-listing"
                  v-if="selected_ser === 1"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenGeneralInfo
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('generalInfo')"
                      class="float-right btn-add user-add-btn min-max-toggle"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <general-information
                        :consultant-id="selected_con"
                        :fullscreen-general-info="fullscreenGeneralInfo"
                      ></general-information>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <!-- <fullscreen
                ref="fullscreenGeneralImage"
                @change="fullscreenChangeGeneralImage"
              >
                <vx-card
                  class="mb-6 sub-cards user-listing"
                  :title="$t('labels.general_images')"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenGeneralImage
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('generalImage')"
                      class="float-right btn-add user-add-btn min-max-toggle"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <general-image-upload
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                      >
                      </general-image-upload>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen> -->

              <fullscreen ref="fullscreen" @change="fullscreenChange">
                <vx-card
                  :title="$t('labels.qualification_of_officers')"
                  class="mb-6 sub-cards"
                  v-if="selected_ser === 1 || selected_ser === 2"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="fullscreen ? 'icon-minimize' : 'icon-maximize'"
                      @click="toggle('officer')"
                    ></vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <qualification-officers-details
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                      >
                      </qualification-officers-details>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenMiscellaneous"
                @change="fullscreenChangeMiscellaneous"
              >
                <vx-card
                  :title="$t('labels.miscellaneous')"
                  class="mb-6 sub-cards miscellaneous"
                  v-if="
                    (selected_ser === 4 ||
                      selected_ser === 2 ||
                      selected_ser === 1) &&
                    renderComponentMis
                  "
                >
                  <div style="position: absolute; right: 72px; top: 3px">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="
                        fullscreenMiscellaneous
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('miscellaneous')"
                    ></vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <miscellaneous
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                        :executive-data="executive_summary_data"
                      ></miscellaneous>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>
            </div>
          </div>
        </div>
      </div>

      <vx-card
        :title="$t('labels.inspection_image')"
        class="mb-6 sub-cards inspection_image"
        v-if="renderComponentIns"
      >
        <InspectionImage
          v-if="folderSections.length"
          ref="inspectionImg"
          :project="project"
          :sectionInfo="folderSections"
          :vesselSubTypeInfo="vesselSubTypeInfo"
          page="inspection"
        ></InspectionImage>
        <div
          class="py-4 text-center"
          v-if="!isUserType('CL') && folderSections.length"
        >
          <vs-button
            class="vs-component vs-button vs-button-warning vs-button-filled"
            color="warning"
            button="submit"
            @click="saveInspection()"
            >{{ $t("labels.save_data") }}</vs-button
          >
        </div>
      </vx-card>

      <div class="vx-row" v-if="false">
        <div class="vx-col w-full">
          <div class="mt-4 md:float-right sm: block md:flex">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-printer"
              @click="printQuestions()"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.print_questions") }}</vs-button
            >
            <vs-button
              color="dark"
              type="filled"
              icon-pack="feather"
              icon="icon-printer"
              @click="printQuestions(1)"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.print_questions_with_guidance") }}</vs-button
            >
            <!-- <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-filter"
              @click="showfilter = !showfilter"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.filter") }}</vs-button
            > -->
          </div>
        </div>
      </div>

      <!-- <vx-card class="filter_card mt-4" v-show="showfilter == true">
        <div class="vx-row filter-default">
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.section") }}</label>
            <v-select
              v-model="section"
              :options="filterSection"
              :reduce="(filterSection) => filterSection.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.designation") }}</label>
            <v-select
              v-model="designation"
              :options="filterDesignation"
              :reduce="(filterDesignation) => filterDesignation.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.query_status") }}</label>
            <v-select
              v-model="query_status_filter"
              :options="filterQueryStatus"
              :reduce="(filterQueryStatus) => filterQueryStatus.value"
              label="label"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-2/3">
            <label class="pl-1">{{ $t("labels.search") }}</label>
            <v-select multiple taggable v-model="search" class="w-full" />
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              v-model="search"
              class="w-full"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              :title="$t('labels.filter')"
              @click="clearFilter()"
              :disabled="
                !this.section &&
                !this.designation &&
                !this.query_status_filter &&
                !this.search
              "
              class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
              >{{ $t("labels.clear") }}</vs-button
            >
          </div>
        </div>
      </vx-card> -->

      <!-- pagination start-->

      <!-- hide for new changes -->

      <!-- <div class="mt-6 question-pagination" v-if="service && question_length >= 1">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 sm: order-2 md:order-1 sm: mt-4 md:mt-0">
            <vs-chip color="primary" class="mt-2 ml-1">{{ start + 1 }} -
              {{ end > question_length ? question_length : end }} of
              {{ question_length }}</vs-chip>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: order-1 md:order-2 inspection-pagination">
            <vs-pagination color="dark" :total="pageCount" v-model="currentx" class="mb-1"></vs-pagination>
          </div>
        </div>
      </div> -->

      <!-- pagination end-->

      <!-- <div class="vx-row w-full mx-0" v-if="service">
        <div class="vx-col sm: w-full mt-6">
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-full md:w-full label-center p-0 question-list question-card">
              <div v-for="(question, qindex) in filtered_questions" :key="qindex">
                <vx-card :title="question.section_reference_number + ' - ' + question.question" class="mb-6 sub-cards">
                  <vs-collapse id="main-collpase">
                    <vs-collapse-item icon-pack="feather" icon-arrow="icon-arrow-down"
                      class="component-button-right question-collapse">

                      For consultant

                      <vx-card class="add-query">
                        <div class="query-text flex justify-between">
                          <feather-icon :title="$t('labels.go_to_question_page')" icon="ExternalLinkIcon"
                            class="cursor-pointer mb-6 mt-6 external-link"
                            @click="$router.push({ name: 'Question', params: { id: question.project_consultant_service_question.id } })">
                          </feather-icon>
                          <span class="query-text-label" v-if="question.project_consultant_service_question.query_text">
                            <label>{{ $t('labels.query_by_reviewer') }} :</label>
                            <span>{{ question.project_consultant_service_question.query_text }}</span>
                          </span>
                          <div class="query-status"
                            v-if="question.project_consultant_service_question.query_status !== 'N'">
                            <span :title="$t('labels.query_status')" color="primary" class="ml-1">{{
                                question.project_consultant_service_question.query_status_name
                            }}</span>
                          </div>
                        </div>
                        <div class="chat-inspection justify-center mb-6">
                          <div class="md:flex text-center chat-btns">
                            <vs-button @click="getComments(qindex)" color="dark" type="border" class="sm: mb-5 md:mb-0">
                              {{ $t('labels.chat') }}</vs-button>
                            <div
                              v-if="question.project_consultant_service_question.query_status !== 'R' && $store.state.userInfo.type == 'A'"
                              class>
                              <vs-button
                                @click="openPopupForRaisedQuery(question.project_consultant_service_question.id)"
                                class="md:ml-4" color="warning" value="R" type="border">{{ $t('labels.raise_query') }}
                              </vs-button>
                            </div>
                            <div class="text-center"
                              v-if="(['R', 'A']).includes(question.project_consultant_service_question.query_status) && $store.state.userInfo.type == 'A'">
                              <vs-button
                                @click="getProjectChangeQueryStatus(question.project_consultant_service_question.id, 'MR')"
                                class="md:ml-4" color="primary" value="MR" type="border">{{
                                    $t('labels.mark_as_resolved')
                                }}</vs-button>
                            </div>
                            <div
                              v-if="question.project_consultant_service_question.query_status === 'R' && $store.state.userInfo.type == 'CN'"
                              class="text-center">
                              <vs-button
                                @click="getProjectChangeQueryStatus(question.project_consultant_service_question.id, 'A')"
                                class="md:ml-4" color="warning" value="A" type="border">{{ $t('labels.query_answered')
                                }}</vs-button>
                            </div>
                          </div>
                        </div>
                      </vx-card>

                      For consultant end

                      <div class="mt-6" v-if="question.all_vessel_types && question.guidance">
                        <div class="mb-2">
                          <label>{{ $t("labels.vessel_type_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{ question.guidance }}</label>
                      </div>
                      <div class="mt-6 mb-4" v-if="!question.all_vessel_types && question.guidance">
                        <div class="mb-2">
                          <label>{{ $t("labels.vessel_type_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{ question.guidance }}</label>
                      </div>
                      <div class="mt-2" v-if="!question.all_flags && question.flag_text != null">
                        <div class="mb-2">
                          <label>{{ $t("labels.flag_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{ question.flag_text }}</label>
                      </div>
                      <div class="mt-2" v-if="question.regulation_reference">
                        <div class="mb-2">
                          <label>{{ $t("labels.regulation_reference") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{ question.regulation_reference }}</label>
                      </div>
                      <div class="vx-row mt-4">
                        <div class="vx-col sm: w-full md:w-1/2">
                          <label class="bold-fields">{{ $t('labels.images') }}</label>
                          <vue-upload-multiple-image :popupText="$t('labels.guidance_images')"
                            :dragText="$t('labels.browse_images')"
                            :ref="'multiple_image_' + question.project_consultant_service_question.id" primaryText
                            browseText markIsPrimaryText accept="image/jpeg, image/png, image/jpg"
                            @upload-success="uploadImageSuccess" @before-remove="beforeRemove"
                            :data-images="question.project_consultant_service_question.images" :maxImage="100"
                            class="w-full mb-2 mt-1 guidance-image" :idUpload="'image-upload' + qindex"
                            name="image_upload"></vue-upload-multiple-image>
                        </div>
                        <div class="vx-col sm: w-full md:w-1/2">
                          <div class="vx-row">
                            <div class="vx-col w-full pr-4 sm: mt-6 md:mt-0">
                              <label class>{{ $t('labels.defect') }}</label>
                              <v-select v-model="question.project_consultant_service_question.defect_id"
                                :options="question.project_consultant_service_question.defects"
                                :reduce="defects => parseInt(defects.id)" label="name" name="defects"
                                v-validate="'required'" :input-changed="() => detectChange()" />
                              <span class="text-danger text-sm">{{ errors.first('defects') }}</span>
                            </div>
                            <div class="vx-col w-full mt-6">
                              <label class>{{ $t('labels.answer') }}</label>
                              <vs-textarea type="text" height="105" class="w-full mb-0 mt-1" name="answer_text"
                                :id="'answer-text' + qindex" maxlength="5000"
                                v-model="question.project_consultant_service_question.answer_text"
                                :placeholder="$t('labels.write_answer')" icon-no-border v-validate="'required'"
                                @keydown="() => detectChange()" />
                            </div>
                          </div>
                        </div>

                        <div class="vx-col sm: w-full mt-6">
                          <div class="vx-row w-full m-0">
                            <label class>{{ $t('labels.audio_file') }}</label>
                            <div class="w-full sm: block md:flex"
                              v-if="!question.project_consultant_service_question.answer_attachment">
                              <div class="vx-col sm: w-full md:w-1/2 mt-1">
                                <input type="file"
                                  :name="question.project_consultant_service_question.answer_attachment" accept=".mp3"
                                  id="answer_attachment" class="mt-1" v-on:change="handleFiles($event, qindex)" />
                                <label for="answer_attachment" class="btn-1">Upload</label>
                              </div>
                              <div class="vx-col sm: w-full md:w-1/2 mt-1"
                                v-if="question.project_consultant_service_question.answer_attachment">
                                <audio controls :id="'audio_control' + qindex">
                                  <source :src="question.project_consultant_service_question.answer_attachment"
                                    type="audio/mpeg" :id="'audio_source' + qindex" />
                                </audio>
                              </div>
                            </div>
                            <div class="w-full sm: block md:flex audio-file" v-else>
                              <div class="vx-col sm: w-full md:w-1/2 mt-1 flex">
                                <p class="self-center audio sm: mb-0" id="audio_name">{{
                                    getFileName(question.project_consultant_service_question.answer_attachment)
                                }}</p>
                                <vs-button color="danger" type="flat" class="mr-1 mt-1 float-right ml-2"
                                  icon-pack="feather" icon="icon-x" v-model="cancel"
                                  @click.prevent="clearFileName(qindex)"></vs-button>
                              </div>
                              <div class="vx-col sm: w-full md:w-1/2"
                                v-if="question.project_consultant_service_question.answer_attachment">
                                <audio controls :id="'audio_control_exit' + qindex">
                                  <source :src="question.project_consultant_service_question.answer_attachment"
                                    type="audio/mpeg" :id="'audio_source' + qindex" />
                                </audio>
                              </div>
                            </div>
                            <div class="w-full flex justify-end"
                              v-if="question.project_consultant_service_question.answer_text != null">
                              <label
                                :class="question.project_consultant_service_question.is_corrected ? 'text-primary' : 'text-danger'">{{
                                    question.project_consultant_service_question.is_corrected
                                      ? "Marked as Correct" : "Marked as Incorrect"
                                }}</label>
                              <vs-switch :value="qindex" :id="'is_corrected' + qindex"
                                v-model="question.project_consultant_service_question.is_corrected" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col sm: w-full mb-4 mt-6">
                          <vs-button
                            class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn float-right"
                            color="dark" :disabled="button_loading" id="save-answer" button="submit"
                            @click.prevent="sendData(question.project_consultant_service_question, question)">{{
                                $t('labels.save_answer')
                            }}</vs-button>
                        </div>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
         <vs-popup class="holamundo" :title="$t('labels.raising_query')" :active.sync="popupActiveRaiseQuery">
        <div class="vx-row">
          <div class="vx-col md:w-1/7">
            <vs-avatar :text="this.$store.state.userInfo.name" color="dark" size="40px" text-color="white" />
          </div>
          <div class="vx-col md:w-10/12">
            <vs-textarea type="text" class="w-full mb-0 mt-1" name="query_text" id="query_text" maxlength="5000"
              v-model="query_text" :placeholder="$t('labels.type_your_query')" icon-no-border />
          </div>
        </div>
        <div class="mt-6 submit-btn">
          <vs-button class="vs-component vs-button vs-button-primary vs-button-filled login-btn" color="primary"
            :disabled="button_loading" id="save-answer" button="submit" @click="submitQueryText()">{{
                $t('labels.submit')
            }}</vs-button>
        </div>
        </vs-popup>
    </div> -->
      <!-- <vs-popup class="holamundo" :title="$t('labels.chat')" :active.sync="popupActive">
      <div>
        <div class="vx-row" v-for="(comment, cindex) in comments" :key="cindex">
          <div class="vx-col w-1/7">
            <vs-avatar :text="comment.user.name" color="dark" size="40px" text-color="white" />
          </div>
          <div class="vx-col sm: w-8/12 md:w-10/12 label-center">
            <label class="comment-avatar">{{ comment.comment }}</label>
          </div>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-1/7">
          <vs-avatar :text="this.$store.state.userInfo.name" color="dark" size="40px" text-color="white" />
        </div>
        <div class="vx-col sm: w-8/12 md:w-10/12">
          <vs-textarea type="text" class="w-full mb-0 mt-1" name="comment" id="comment" maxlength="5000"
            v-model="comment" :placeholder="$t('labels.type_message')" icon-no-border />
        </div>
      </div>
      <div class="mt-6 submit-btn">
        <vs-button class="vs-component vs-button vs-button-primary vs-button-filled login-btn" color="primary"
          :disabled="button_loading" id="save-answer" button="submit" @click="addProjectQuestionComments()">{{
              $t('labels.submit')
          }}</vs-button>
      </div>
     </vs-popup>
     <vs-popup class="holamundo" :title="$t('labels.raising_query')" :active.sync="popupActiveRaiseQuery">
      <div class="vx-row">
        <div class="vx-col w-1/7">
          <vs-avatar :text="this.$store.state.userInfo.name" color="dark" size="40px" text-color="white" />
        </div>
        <div class="vx-col w-10/12">
          <vs-textarea type="text" class="w-full mb-0 mt-1" name="query_text" id="query_text" maxlength="5000"
            v-model="query_text" :placeholder="$t('labels.type_your_query')" icon-no-border />
        </div>
      </div>
      <div class="mt-6 submit-btn">
        <vs-button class="vs-component vs-button vs-button-primary vs-button-filled login-btn" color="primary"
          :disabled="button_loading" id="save-answer" button="submit" @click="submitQueryText()">{{
              $t('labels.submit')
          }}</vs-button>
      </div>
     </vs-popup> -->

      <!-- new code added for demo tree structure -->

      <fullscreen
        ref="fullscreenQuestion"
        v-if="false"
        @change="fullscreenChangeQuestion"
      >
        <div class="position-relative">
          <div
            v-if="service"
            class="questionair_card_position"
            style="z-index: 0 !important"
          >
            <vx-card
              :title="$t('labels.questionnaire')"
              class="lead-listing z-index-bottom"
              style="min-height: 700px"
            >
              <div class="component-button-right">
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  class="float-right btn-add user-add-btn min-max-toggle margin-minus"
                  :icon="fullscreenQuestion ? 'icon-minimize' : 'icon-maximize'"
                  @click="toggle('question')"
                >
                </vs-button>
              </div>
              <!-- <div> -->
              <div class="row">
                <div class="col-lg-4 col-sm-6">
                  <div class="questionary_position">
                    <div>
                      <search-icon
                        style="
                          transition-duration: 500ms;
                          cursor: pointer;
                          margin-top: -12px;
                        "
                        v-if="search_icon"
                        @click="search_Icon"
                        size="1.5x"
                        class="custom-class"
                      ></search-icon>
                      <vs-input
                        v-if="input_placeholder"
                        style="line-height: 15px"
                        icon="search"
                        placeholder="Search"
                        @keyup.enter="searchInput(text)"
                        v-model="text"
                      />
                      <button class="clear-btn">
                        <x-icon
                          v-if="input_placeholder"
                          @click="clear"
                          size="1.5x"
                          class="custom-class"
                        ></x-icon>
                      </button>
                    </div>
                    <div class="collapse_position">
                      <i
                        @click="collapse"
                        title="collapse"
                        class="fas fa-angle-down rotate-icon"
                      ></i>
                    </div>
                    <div>
                      <details
                        v-for="(section, section_index) in question_section"
                        :key="section.id"
                      >
                        <!-- <summary @click="change(2)">2. Safety management </summary> -->
                        <summary
                          class="text_click"
                          @click="showSectionDetails(section)"
                        >
                          {{ section.section_number }} {{ section.name }}
                        </summary>
                        <details
                          class="sub_section"
                          v-for="(
                            sub_section, sub_section_index
                          ) in section.children"
                          :key="sub_section.id"
                        >
                          <summary
                            class="text_click"
                            v-if="section.children"
                            @click="subSectionDetails(sub_section, section)"
                          >
                            {{ sub_section.section_number }}
                            {{ sub_section.name }}
                          </summary>
                          <details
                            class="question_position"
                            v-for="(
                              questions, question_index
                            ) in sub_section.questionslists"
                            :key="questions.id"
                          >
                            <summary
                              class="text_click"
                              @click="
                                questionairy(questions, {
                                  section_index,
                                  sub_section_index,
                                  question_index,
                                })
                              "
                            >
                              {{ questions.question_number }}
                              {{ questions.question }}
                            </summary>
                          </details>
                        </details>
                      </details>
                    </div>
                  </div>
                </div>
                <div
                  v-if="section_data"
                  class="safety_managemetnt col-lg-8 col-sm-6"
                >
                  <h3 class="text_header">
                    {{ selected_section.section_number }}.
                    {{ selected_section.name }}
                  </h3>
                  <div class="status">
                    <vs-button color="success" type="filled"
                      >Mark all completed</vs-button
                    >
                  </div>
                  <vs-card
                    class="card_position shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                  >
                    <div slot="header">
                      <div>
                        <h3>{{ section_details.sub_sections }}</h3>
                        <h4>Total section</h4>
                      </div>
                    </div>
                  </vs-card>
                  <vs-card
                    class="card_position shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                  >
                    <div slot="header">
                      <div>
                        <h3>{{ section_details.total_questions }}</h3>
                        <h4>Total question</h4>
                      </div>
                    </div>
                  </vs-card>
                  <vs-card
                    class="card_position shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                  >
                    <div slot="header">
                      <div>
                        <h3>{{ section_details.completed_answers }}</h3>
                        <h4>Total completed answer</h4>
                      </div>
                    </div>
                  </vs-card>
                  <vs-card
                    class="card_position shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                  >
                    <div slot="header">
                      <div>
                        <h3>{{ section_details.pending_answers }}</h3>
                        <h4>Total pending Answer</h4>
                      </div>
                    </div>
                  </vs-card>
                </div>
                <div
                  v-if="selectedSubsection"
                  class="safety_managemetnt col-lg-8 col-sm-6"
                >
                  <h3 class="text_header">
                    {{ selected_sub_section.section_number }}
                    {{ selected_sub_section.name }}
                  </h3>
                  <div class="status">
                    <vs-button class="" color="success" type="filled"
                      >Mark all completed</vs-button
                    >
                  </div>
                  <div class="row">
                    <vs-card
                      class="card_position2 shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                    >
                      <div slot="header">
                        <div>
                          <h3>{{ sub_section_details.total_questions }}</h3>
                          <h4>Total question</h4>
                        </div>
                      </div>
                    </vs-card>
                    <vs-card
                      class="card_position2 shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                    >
                      <div slot="header">
                        <div>
                          <h3>{{ sub_section_details.completed_answers }}</h3>
                          <h4>Total completed Answers</h4>
                        </div>
                      </div>
                    </vs-card>
                    <vs-card
                      class="card_position2 shadow-none mr-2 align-items-center justify-center col-lg-4 col-md-6"
                    >
                      <div slot="header">
                        <div>
                          <h3>{{ sub_section_details.pending_answers }}</h3>
                          <h4>Total pending Answers</h4>
                        </div>
                      </div>
                    </vs-card>
                  </div>
                </div>

                <!-- For certhificate registery all chat and query between admin and user -->

                <div class="col-lg-8 col-sm-6">
                  <div v-if="questionairy_details" class="">
                    <h3 class="text_header_question">
                      {{ que_num }} {{ que_name }}
                    </h3>
                    <div class="chat_raise_query">
                      <div class="chat-inspection justify-content-end mb-6">
                        <div class="md:flex text-center chat-btns d-flex">
                          <vs-button
                            @click="getComments()"
                            color="dark"
                            type="border"
                            class="sm: mb-5 md:mb-0"
                          >
                            {{ $t("labels.chat") }}</vs-button
                          >
                          <div
                            v-if="
                              answer_details.query_status !== 'R' &&
                              $store.state.userInfo.type == 'A'
                            "
                            class
                          >
                            <vs-button
                              @click="
                                openPopupForRaisedQuery(
                                  answer_details.question_id
                                )
                              "
                              class="md:ml-4"
                              color="warning"
                              value="R"
                              type="border"
                              >{{ $t("labels.raise_query") }}
                            </vs-button>
                          </div>
                          <div
                            class="text-center"
                            v-if="
                              ['R', 'A'].includes(
                                answer_details.query_status
                              ) && $store.state.userInfo.type == 'A'
                            "
                          >
                            <vs-button
                              @click="
                                getProjectChangeQueryStatus(
                                  answer_details.id,
                                  'MR'
                                )
                              "
                              class="md:ml-4"
                              color="primary"
                              value="MR"
                              type="border"
                              >{{ $t("labels.mark_as_resolved") }}
                            </vs-button>
                          </div>
                          <div
                            v-if="
                              answer_details.query_status === 'R' &&
                              $store.state.userInfo.type == 'CN'
                            "
                            class="text-center"
                          >
                            <vs-button
                              @click="
                                getProjectChangeQueryStatus(
                                  answer_details.id,
                                  'A'
                                )
                              "
                              class="md:ml-4"
                              color="warning"
                              value="A"
                              type="border"
                              >{{ $t("labels.query_answered") }}
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="image_upload">
                          <div class="w-100">
                            <label class="bold-fields">{{
                              $t("labels.images")
                            }}</label>
                            <vue-upload-multiple-image
                              :popupText="$t('labels.guidance_images')"
                              :dragText="$t('labels.browse_images')"
                              :ref="'multiple_image_' + answer_details.id"
                              primaryText
                              browseText
                              markIsPrimaryText
                              accept="image/jpeg, image/png, image/jpg"
                              :data-images="image_path"
                              @upload-success="uploadImageSuccess"
                              @before-remove="beforeRemove"
                              :maxImage="100"
                              class="w-full mb-2 mt-1 guidance-image"
                              :idUpload="'image-upload' + answer_details.id"
                              name="image_upload"
                            >
                            </vue-upload-multiple-image>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-8">
                        <div class="new d-flex justify-content-end">
                          <div class="w-100">
                            <div class="vx-row">
                              <div class="vx-col w-full pr-4 sm: mt-6 md:mt-0">
                                <label class>{{ $t("labels.defect") }}</label>
                                <v-select
                                  v-model="answer_details.defect_id"
                                  :options="answer_details.defects"
                                  :reduce="(defects) => parseInt(defects.id)"
                                  label="name"
                                  name="defects"
                                  v-validate="'required'"
                                  :input-changed="() => detectChange()"
                                />
                                <span class="text-danger text-sm">{{
                                  errors.first("defects")
                                }}</span>
                              </div>
                              <div class="vx-col w-full mt-6">
                                <label class>{{ $t("labels.answer") }}</label>
                                <vs-textarea
                                  type="text"
                                  height="105"
                                  class="w-full mb-0 mt-1"
                                  maxlength="5000"
                                  name="answer_text"
                                  v-model="answer_details.answer_text"
                                  :placeholder="$t('labels.write_answer')"
                                  icon-no-border
                                  v-validate="'required'"
                                  @keydown="() => detectChange()"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <vs-popup
                      class="holamundo"
                      :title="$t('labels.chat')"
                      :active.sync="popupActive"
                    >
                      <div>
                        <div
                          class="vx-row"
                          v-for="(comment, cindex) in comments"
                          :key="cindex"
                        >
                          <div class="vx-col w-1/7">
                            <vs-avatar
                              :text="comment.user.name"
                              color="dark"
                              size="40px"
                              text-color="white"
                            />
                          </div>
                          <div
                            class="vx-col sm: w-8/12 md:w-10/12 label-center"
                          >
                            <label class="comment-avatar">{{
                              comment.comment
                            }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="vx-row mt-4">
                        <div class="vx-col w-1/7">
                          <vs-avatar
                            :text="this.$store.state.userInfo.name"
                            color="dark"
                            size="40px"
                            text-color="white"
                          />
                        </div>
                        <div class="vx-col sm: w-8/12 md:w-10/12">
                          <vs-textarea
                            type="text"
                            class="w-full mb-0 mt-1"
                            name="comment"
                            id="comment"
                            maxlength="5000"
                            v-model="comment"
                            :placeholder="$t('labels.type_message')"
                            icon-no-border
                          />
                        </div>
                      </div>
                      <div class="mt-6 submit-btn">
                        <vs-button
                          class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
                          color="primary"
                          :disabled="button_loading"
                          id="save-answer"
                          button="submit"
                          @click="addProjectQuestionComments()"
                          >{{ $t("labels.submit") }}</vs-button
                        >
                      </div>
                    </vs-popup>
                    <vs-popup
                      class="holamundo"
                      :title="$t('labels.raising_query')"
                      :active.sync="popupActiveRaiseQuery"
                    >
                      <div class="vx-row">
                        <div class="vx-col md:w-1/7">
                          <vs-avatar
                            :text="this.$store.state.userInfo.name"
                            color="dark"
                            size="40px"
                            text-color="white"
                          />
                        </div>
                        <div class="vx-col md:w-10/12">
                          <vs-textarea
                            type="text"
                            class="w-full mb-0 mt-1"
                            name="query_text"
                            id="query_text"
                            maxlength="5000"
                            v-model="answer_details.query_text"
                            :placeholder="$t('labels.type_your_query')"
                            icon-no-border
                          />
                        </div>
                      </div>
                      <div class="mt-6 submit-btn">
                        <vs-button
                          class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
                          color="primary"
                          :disabled="button_loading"
                          id="save-answer"
                          button="submit"
                          @click="submitQueryText()"
                        >
                          {{ $t("labels.submit") }}</vs-button
                        >
                      </div>
                    </vs-popup>
                    <div class="">
                      <div class="d-flex mt-6">
                        <div class="ml-10 w-full m-0">
                          <label class>{{ $t("labels.audio_file") }}</label>
                          <div
                            class="w-full sm: block md:flex"
                            v-if="!answer_details.answer_attachment"
                          >
                            <div class="vx-col sm: w-full md:w-1/2 mt-1">
                              <input
                                type="file"
                                :name="answer_details.answer_attachment"
                                accept=".mp3"
                                id="answer_attachment"
                                class="mt-1"
                                v-on:change="
                                  handleFiles($event, answer_details.id)
                                "
                              />
                              <label for="answer_attachment" class="btn-1"
                                >Upload</label
                              >
                            </div>
                            <div
                              class="vx-col sm: w-full md:w-1/2 mt-1"
                              v-if="answer_details.answer_attachment"
                            >
                              <audio
                                controls
                                :id="'audio_control' + answer_details.id"
                              >
                                <source
                                  :src="answer_details.answer_attachment"
                                  type="audio/mpeg"
                                  :id="'audio_source' + answer_details.id"
                                />
                              </audio>
                            </div>
                          </div>
                          <div
                            class="w-full sm: block md:flex audio-file"
                            v-else
                          >
                            <div class="vx-col sm: w-full md:w-1/2 mt-1 flex">
                              <p
                                class="self-center audio sm: mb-0"
                                id="audio_name"
                              >
                                {{
                                  getFileName(answer_details.answer_attachment)
                                }}
                              </p>
                              <vs-button
                                color="danger"
                                type="flat"
                                class="mr-1 mt-1 float-right ml-2"
                                icon-pack="feather"
                                icon="icon-x"
                                v-model="cancel"
                                @click.prevent="clearFileName(answer_details)"
                              ></vs-button>
                            </div>
                            <div
                              class="vx-col sm: w-full md:w-1/2"
                              v-if="answer_details.answer_attachment"
                            >
                              <audio
                                controls
                                :id="
                                  'audio_control_exit' +
                                  answer_details.answer_attachment.id
                                "
                              >
                                <source
                                  :src="answer_details.answer_attachment"
                                  type="audio/mpeg"
                                  :id="
                                    'audio_source' +
                                    answer_details.answer_attachment.id
                                  "
                                />
                              </audio>
                            </div>
                          </div>
                        </div>
                        <div class="w-100">
                          <div class="decission m-0 w-100">
                            <div class="flex justify-end mb-1">
                              <label
                                :class="
                                  answer_details.is_corrected
                                    ? 'text-primary'
                                    : 'text-danger'
                                "
                                >{{
                                  answer_details.is_corrected
                                    ? "Rectified"
                                    : "Is it Rectified"
                                }}</label
                              >
                              <vs-switch
                                :id="'is_corrected'"
                                v-model="answer_details.is_corrected"
                              />
                            </div>
                          </div>
                          <div class="save_button">
                            <vs-button
                              class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn float-right"
                              color="dark"
                              :disabled="button_loading"
                              id="save-answer"
                              button="submit"
                              @click.prevent="sendData()"
                            >
                              {{ $t("labels.save_answer") }}</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="next_button">
                        <div>
                          <vs-button
                            class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn float-right"
                            color="dark"
                            v-if="nxt_question_index_details"
                            :disabled="button_loading"
                            id="next-question"
                            @click="showNextQuestion"
                          >
                            {{ $t("labels.next") }}</vs-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </vx-card>
          </div>
        </div>
      </fullscreen>
    </div>
    <!-- <div class="vx-col sm: w-full mb-4 mt-6" v-if="service">
      <vs-button
        class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn save-all-btn float-right z-10"
        color="warning" :disabled="button_loading" id="save-answer" @click.prevent="sendAllData">{{
            $t('labels.save_all_answer')
        }}</vs-button>
    </div> -->
  </div>
</template>
<script>
import { XIcon } from "vue-feather-icons";
import { SearchIcon } from "vue-feather-icons";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ViewProject from "@/layouts/components/projects/view-project.vue";
import GeneralImageUpload from "@/layouts/components/projects/general-images-upload.vue";
import QualificationOfficersDetails from "@/layouts/components/projects/qualification-officers-details";
import VesselAssessment from "@/layouts/components/projects/vessel-assessment";
import Miscellaneous from "@/layouts/components/projects/miscellaneous";
import ExecutiveSummary from "@/layouts/components/projects/executive-summary";
import GeneralInformation from "@/layouts/components/projects/general-information";
import vSelect from "vue-select";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
import ExecutiveSummaryMax from "@/layouts/components/projects/executive-summary-max";
import InspectionImage from "@/components/inspection-image";

Vue.use(fullscreen);
export default {
  data() {
    return {
      isDropped: false,
      section_data: false,
      selectedSubsection: false,
      active: true,
      questionairy_details: false,
      renderComponent: true,
      renderComponentMis: true,
      renderComponentIns: true,
      answer_text: "",
      is_corrected: false,
      cancel: "",
      images: [],
      service: null,
      services_drop: [],
      consultant: "",
      consultants_drop: [],
      consultants: [],
      questions: "",
      question: [],
      consultant_services_array: [],
      question_drop: [],
      service_ids: "",
      id: this.$route.params.id,
      model: "project",
      defects: [],
      defect_id: null,
      defects_drop: [],
      selected_con: "",
      selected_ser: "",
      comments: [],
      comment: "",
      popupActive: false,
      popupActiveRaiseQuery: false,
      query_text: "",
      targeted_question_id: null,
      selected_question_index: null,
      raw_consultants: [],
      project: {},
      currentx: 1, // current page
      question_length: 0, // length of all questions
      perPage: 10, // perPage
      start: 1,
      end: 10,
      all_vessel_types: "",
      showfilter: false,
      search: "",
      designation: "",
      section_reference_number: null,
      section: 0,
      query_status_filter: "",
      filterSection: [{ name: "All Section", id: 0 }],
      filterDesignation: [{ name: "All Designation", id: "" }],
      filterQueryStatus: [
        { label: "All Query", value: "" },
        { label: "No Query", value: "N" },
        { label: "Query Reolved", value: "MR" },
        { label: "Query Raised", value: "R" },
        { label: "Query Answered", value: "A" },
      ],
      executive_summary_data: "",
      isChanged: false,
      fullscreen: false,
      fullscreenExecutive: false,
      fullscreenVessel: false,
      fullscreenQuestion: false,
      fullscreenGeneralInfo: false,
      fullscreenGeneralImage: false,
      fullscreenMiscellaneous: false,
      fullscreenInspection: false,
      change_component: true,
      activeslider: "questionairy",
      question_section: [],
      sub_section_question: [],
      section_details: "",
      selected_section: "",
      selected_sub_section: "",
      sub_section_details: "",
      answer_details: "",
      que_num: "",
      que_name: "",
      section_id: "",
      image: [],
      image_path: [],
      subSection: "",
      section_num: "",
      que: "",
      text: "",
      project_details: [],
      search_icon: true,
      input_placeholder: false,
      nxt_question_index_details: null,
      folderSections: [],
      vesselTypeInfo: null,
      vesselSubTypeInfo: null,
    };
  },
  components: {
    ExecutiveSummaryMax,
    VueUploadMultipleImage,
    ViewProject,
    GeneralImageUpload,
    "v-select": vSelect,
    QualificationOfficersDetails,
    Miscellaneous,
    GeneralInformation,
    ExecutiveSummary,
    VesselAssessment,
    SearchIcon,
    XIcon,
    InspectionImage,
  },
  watch: {
    input_placeholder(val) {
      if (val) {
        this.search_icon = false;
      }
    },
    text(value) {
      if (value == "") {
        this.collapse();
      }
    },
    selected_con(val) {
      // if con drop is cleared than clear service and its drop
      if (!val) {
        this.service = null;
        this.services_drop = [];
      }
    },
  },
  computed: {
    filtered_questions() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];
      let question = [];
      let that = this;

      that.executive_summary_data = "";
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          if (ser_target === 1) {
            that.executive_summary_data =
              el.project_consultant.safety_inspection_executive_summary_template;
          }
          if (ser_target === 2) {
            that.executive_summary_data =
              el.project_consultant.navigation_assessment_executive_summary_template;
          }
          if (ser_target === 3) {
            that.executive_summary_data =
              el.project_consultant.internal_audit_executive_summary_template;
          }
          if (ser_target === 4) {
            that.executive_summary_data =
              el.project_consultant.visit_report_executive_summary_template;
          }
          if (ser_target === 5) {
            that.executive_summary_data =
              el.project_consultant.technical_inspection_executive_summary_template;
          }
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              question = el.project_consultant_service.questions;
              question.forEach(function (item, index) {
                if (ser_target === 1) {
                  if (item.section_id !== 1) {
                    questions.push(item);
                  }
                } else {
                  questions = question;
                }
              });
              //start filter process
              if (
                that.designation ||
                that.section ||
                that.query_status_filter ||
                that.search
              ) {
                if (questions.length > 0) {
                  that.currentx = 1;
                  questions = questions.filter(function (que) {
                    let designationFlag = false;
                    let sectionFlag = false;
                    let statusFlag = false;
                    let searchFlag = false;
                    if (que.all_designations || !that.designation)
                      designationFlag = true;
                    else
                      que.designations.forEach(function (d) {
                        if (d.id == that.designation) designationFlag = true;
                      });

                    if (
                      que.section_id == that.section ||
                      que.sub_section_id == that.section ||
                      !that.section
                    )
                      sectionFlag = true;
                    if (
                      que.project_consultant_service_question.query_status ==
                        that.query_status_filter ||
                      !that.query_status_filter
                    )
                      statusFlag = true;
                    if (
                      !that.search ||
                      that.hsearch(que.question) ||
                      que.section_reference_number
                        .toLowerCase()
                        .includes(that.search)
                    )
                      searchFlag = true;

                    return (
                      designationFlag && sectionFlag && statusFlag && searchFlag
                    );
                  });
                }
              }
              questions.forEach(function (que) {
                // Display vessel_types guidance
                that.type_id = that.project.vessel_type_id;
                that.sub_type_id = that.project.vessel_sub_type_id;
                if (!que.all_vessel_types) {
                  let vessel_types = que.vessel_types;

                  vessel_types.forEach((element) => {
                    let que_vessel_type =
                      element.question_vessel_type.vessel_type_id;

                    if (que_vessel_type === that.type_id) {
                      let vessel_sub_types =
                        element.question_vessel_type.vessel_sub_types;

                      vessel_sub_types.forEach((ele) => {
                        let que_subvessel_type = ele.id;
                        if (que_subvessel_type === that.sub_type_id) {
                          que.guidance = element.question_vessel_type.guidance;
                          return;
                        }
                      });
                    }
                  });
                } else {
                  que.guidance = que.vessel_type_guidance;
                }
              });

              questions.forEach(function (que) {
                // Display flag guidance
                let flag_id = that.project.vessel.flag_id;
                if (!que.all_flags) {
                  let flags = que.flags;
                  flags.forEach((element) => {
                    let que_flag = element.id;

                    if (que_flag === flag_id) {
                      que.flag_text = que.flag_guidance;
                      return;
                    }
                  });
                  return;
                }
              });
            }

            that.question_length = questions.length;
          });
        }
      });

      /**
      Main Pagination Logic
      start = currentpage - 1 * perpage
       */
      this.start = (this.currentx - 1) * this.perPage;
      this.end = this.start + this.perPage;
      return questions.slice(this.start, this.end);
    },
    pageCount() {
      let l = this.question_length,
        s = this.perPage;
      return Math.ceil(l / s);
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  mounted() {
    this.executive_summary_data = "";
    this.getProject();
    // The only UI that consumes this (the designation filter dropdown) is
    // commented out further down this page, so this call is unused dead
    // weight for everyone — and Client may not even have permission on the
    // `designations` module in some environments, causing an avoidable 403.
    if (!this.isUserType("CL")) {
      this.getDesignations();
    }
    this.getSection();
    this.collapse();
    this.getProjectFolderSubFolder();
  },
  methods: {
    async getProjectFolderSubFolder() {
      const projectId = this.$route.params.id;
      const response = await this.getHTTPGetResponse(
        `/projects/${projectId}/folder/subfolder/get-folders`
      );
      if (response && response.data) {
        this.folderSections = response.data.folders.map((v) => {
          return {
            ...v,
            imageUrl: v.ga_plan_image || null,
            location: v.location ? JSON.parse(v.location) : null,
            subFolders: v.subFolders.map((subFolder) => ({
              ...subFolder,
              location: subFolder.location
                ? JSON.parse(subFolder.location)
                : null,
            })),
          };
        });
      }
    },
    showNextQuestion() {
      if (this.nxt_question_index_details && this.question_section) {
        const { section_index, sub_section_index, question_index } =
          this.nxt_question_index_details;
        const question =
          this.question_section[section_index].children[sub_section_index]
            .questionslists[question_index];
        if (question) {
          this.questionairy(question, {
            section_index,
            sub_section_index,
            question_index,
          });
        }
      }
    },
    updateTheValue() {
      this.getProject();
    },
    clear() {
      this.input_placeholder = false;
      this.search_icon = true;
      this.collapse();
    },
    search_Icon() {
      this.input_placeholder = true;
    },
    getExecutiveSummary() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let that = this;

      that.executive_summary_data = "";
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          if (ser_target === 1) {
            that.executive_summary_data =
              el.project_consultant.safety_inspection_executive_summary_template;
          }
          if (ser_target === 2) {
            that.executive_summary_data =
              el.project_consultant.navigation_assessment_executive_summary_template;
          }
          if (ser_target === 3) {
            that.executive_summary_data =
              el.project_consultant.internal_audit_executive_summary_template;
          }
          if (ser_target === 4) {
            that.executive_summary_data =
              el.project_consultant.visit_report_executive_summary_template;
          }
          if (ser_target === 5) {
            that.executive_summary_data =
              el.project_consultant.technical_inspection_executive_summary_template;
          }
        }
      });
    },
    getCurrentSelectedConSer() {
      this.project.consultants.forEach((con) => {
        if (con.id == this.selected_con) {
          con.project_consultant.services.forEach((ser) => {
            if (ser.id == this.selected_ser) {
              this.project_details = ser.project_consultant_service.questions;
            }
          });
        }
      });
    },
    searchInput(txt) {
      const newlist = [];
      this.question_section.forEach((text) => {
        const sub_section = [];
        text.children.forEach((sub) => {
          const question = [];
          sub.questionslists.filter((que) => {
            if (que.question.toLowerCase().includes(txt.toLowerCase())) {
              question.push(que);
            }
          });
          sub.questionslists = question;
          if (question.length > 0) {
            sub_section.push(sub);
          }
        });
        text.children = sub_section;
        if (sub_section.length > 0) {
          newlist.push(text);
        }
      });
      this.question_section = newlist;
      this.expandTree();
    },
    expandTree() {
      var x = document.getElementsByTagName("details");
      var i;
      for (i = 0; i < x.length; i++) {
        x[i].setAttribute("open", "true");
      }
    },
    subSectionDetails(sub_section, section) {
      this.subSection = sub_section;
      this.section_num = section;
      this.getQuestions(this.subSection, this.section_num);
    },
    open() {},
    getNextQuestionIndex(indexDetail) {
      let { section_index, sub_section_index, question_index } = indexDetail;
      if (
        this.question_section[section_index].children[sub_section_index]
          .questionslists.length >
        question_index + 1
      ) {
        question_index = question_index + 1;
      } else if (
        this.question_section[section_index].children.length >
        sub_section_index + 1
      ) {
        sub_section_index = sub_section_index + 1;
        question_index = 0;
      } else if (this.question_section.length > section_index + 1) {
        section_index = section_index + 1;
        sub_section_index = 0;
        question_index = 0;
      } else {
        section_index = null;
      }

      if (
        section_index != null &&
        !this.question_section[section_index].children[sub_section_index]
          .questionslists.length
      ) {
        const data = this.getNextQuestionIndex({
          section_index,
          sub_section_index,
          question_index,
        });
        if (data) {
          section_index = data.section_index;
          sub_section_index = data.sub_section_index;
          question_index = data.question_index;
        }
      }
      return { section_index, sub_section_index, question_index };
    },
    questionairy(que, indexDetail) {
      const res = this.getNextQuestionIndex(indexDetail);
      if (res && res.section_index != null) {
        this.nxt_question_index_details = res;
      } else {
        this.nxt_question_index_details = null;
      }

      this.que = que;
      this.image_path = [];
      this.image = [];
      this.questionairy_details = true;
      this.selectedSubsection = false;
      this.section_data = false;
      this.sub_section_question.forEach((el) => {
        if (el.id == que.id) {
          this.answer_details = el.project_consultant_service_question;
        }
      });
      this.que_num = que.question_number;
      this.que_name = que.question;
      if (this.answer_details.images != null) {
        let data1 = this.answer_details.images.map((url) => {
          return {
            path: url,
            // default: 1,
            // highlight: 1,
          };
        });
        this.image_path = data1;
      }
      this.getQuestions_updates(this.subSection, this.section_num);
    },
    async getSection() {
      let response = await this.getHTTPPostResponse(
        "questions/treeview/section-list"
      );
      if (response) {
        this.question_section = response.data.sections;
      }
    },
    async getQuestions_updates(sub_section, section) {
      let input = {
        section_id: section.id,
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        service_id: this.selected_ser,
        sub_section_id: sub_section.id,
      };
      this.section_id = section.id;
      let response = await this.getHTTPPostResponse(
        "questions/treeview/question-list",
        input
      );
      if (response) {
        this.sub_section_question = response.data.questions;
      }
    },
    async getQuestions(sub_section, section) {
      let input = {
        section_id: section.id,
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        service_id: this.selected_ser,
        sub_section_id: sub_section.id,
      };
      this.section_id = section.id;
      let response = await this.getHTTPPostResponse(
        "questions/treeview/question-list",
        input
      );
      if (response) {
        this.sub_section_question = response.data.questions;
      }
      await this.showSubSectionDetails(sub_section, section);
    },
    async showSubSectionDetails(sub_section, section) {
      this.selected_sub_section = sub_section;
      let input = {
        section_id: section.id,
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        service_id: this.selected_ser,
        sub_section_id: sub_section.id,
      };
      let response = await this.getHTTPPostResponse(
        "questions/treeview/question-list",
        input
      );
      if (response) {
        this.sub_section_details = response.data;
        this.section_data = false;
        this.questionairy_details = false;
        this.selectedSubsection = true;
      }
    },
    async showSectionDetails(sec) {
      this.selected_section = sec;
      let input = {
        section_id: sec.id,
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        service_id: this.selected_ser,
      };
      let response = await this.getHTTPPostResponse(
        "questions/treeview/question-list",
        input
      );
      if (response) {
        this.section_details = response.data;
        this.selectedSubsection = false;
        this.questionairy_details = false;
        this.section_data = true;
      }
    },
    collapse() {
      this.text = "";
      this.getSection();
      const details = document.querySelectorAll("details");
      details.forEach((targetDetail) => {
        // targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
        // });
      });
      (this.section_data = false),
        (this.selectedSubsection = false),
        (this.questionairy_details = false);
    },
    toggle(type) {
      if (type == "executive") {
        this.$refs.fullscreenExecutive.toggle();
        // this.change_component = !this.change_component;
        this.getExecutiveSummary();
      }
      if (type == "vessel") {
        this.$refs.fullscreenVessel.toggle();
      }
      if (type == "question") {
        this.$refs.fullscreenQuestion.toggle();
      }
      if (type == "generalInfo") {
        this.$refs.fullscreenGeneralInfo.toggle();
      }
      if (type == "officer") {
        this.$refs.fullscreen.toggle();
      }
      if (type == "generalImage") {
        this.$refs.fullscreenGeneralImage.toggle();
      }
      if (type == "miscellaneous") {
        this.$refs.fullscreenMiscellaneous.toggle();
      }
      if (type == "inspection") {
        this.$refs.fullscreenInspection.toggle();
      }
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    fullscreenChangeExecutive(fullscreen) {
      this.fullscreenExecutive = fullscreen;
    },
    fullscreenChangeVessel(fullscreen) {
      this.fullscreenVessel = fullscreen;
    },
    fullscreenChangeQuestion(fullscreen) {
      this.fullscreenQuestion = fullscreen;
    },
    fullscreenChangeGeneralInfo(fullscreen) {
      this.fullscreenGeneralInfo = fullscreen;
    },
    fullscreenChangeGeneralImage(fullscreen) {
      this.fullscreenGeneralImage = fullscreen;
    },
    fullscreenChangeMiscellaneous(fullscreen) {
      this.fullscreenMiscellaneous = fullscreen;
    },
    fullscreenChangeInspection(fullscreen) {
      this.fullscreenInspection = fullscreen;
    },
    hsearch(question) {
      let tags = this.search.toLowerCase().split(" ");

      let que = question.toLowerCase();

      let flag = false;
      for (let i = 0; i < tags.length; i++) {
        if (que.includes(tags[i])) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    openPopupForRaisedQuery(id) {
      this.targeted_question_id = id;
      this.popupActiveRaiseQuery = true;
    },
    async submitQueryText() {
      let input = {
        project_consultant_service_question_id: this.answer_details.id,
        status: "R",
        query_text: this.answer_details.query_text,
      };

      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.popupActiveRaiseQuery = false;
        this.query_text = "";
        this.questionairy(this.que);
        this.getProject();
      }
    },
    /**
     * @function setSelectedCon
     * @description this function will invoke whenever v-select of consultans changes value
     */
    setSelectedCon(value) {
      //fist clear selected service and its dropdown array
      this.service = null;
      this.services_drop = [];
      //set current v -select value as a selected_con
      this.selected_con = value;

      // get services for selected cont
      let consultants = this.raw_consultants;
      var selectedCon = consultants.filter(function (el) {
        return el.id == value;
      });
      let service_req = selectedCon[0].project_consultant.services;
      let filteredServices = [];
      for (var i = 0; i < service_req.length; i++) {
        let obj = { id: service_req[i].id, name: service_req[i].name };
        filteredServices.push(obj);
      }
      this.services_drop = filteredServices;
    },
    setSelectedSer(value) {
      this.selected_ser = value;
      this.renderComponent = true;
      this.renderComponentMis = true;
      this.renderComponentIns = true;

      // this.$nextTick(() => {
      //   // Add the component back in
      //   this.renderComponent = true;
      //   this.renderComponentMis = true;
      // });
      this.executive_summary_data = "";
      this.getCurrentSelectedConSer();
      this.getExecutiveSummary();
    },
    async sendAllData() {
      let is_error = false;
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];

      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              questions = el.project_consultant_service.questions;
            }
          });
        }
      });

      let input = {
        answers: [],
      };

      // let questions = this.questions;
      questions.forEach((question) => {
        let data = question.project_consultant_service_question;
        var images;
        var name = "multiple_image_" + data.id;
        if (this.$refs[name] && this.$refs[name].length) {
          images = this.$refs[name][0].images;
        } else {
          images = data.images;
        }

        var images_url = images.map((image) => {
          return image.s3_url;
        });
        var answer = {
          project_consultant_service_question_id: data.id,
          defect_id: data.defect_id,
          answer_text: data.answer_text,
          answer_attachment: data.answer_attachment,
          images: images_url,
          is_corrected: data.is_corrected,
        };

        if (answer.defect_id || answer.answer_text) {
          if (answer.defect_id && answer.answer_text) {
            input.answers.push(answer);
          } else {
            is_error = true;
            this.displayError(
              "Please fill required details: Question No. " +
                question.question_number +
                "-" +
                question.question +
                "details"
            );
          }
        }
      });
      if (input.answers.length > 0 && is_error == false) {
        this.recordInspection(input);
      }
    },
    async recordInspection(input) {
      let url = "/projects/inspection/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        this.getProject();
      }
    },
    async sendData() {
      var name = "multiple_image_" + this.answer_details.id;
      // var images = this.$refs[name][0].images;
      // var images = this.$refs[name] ? this.$refs[name][0].images : NULL;
      // var images_url = images.map((image) => {
      //   return image.s3_url;
      // });
      var answer = {
        project_consultant_service_question_id: this.answer_details.id,
        defect_id: this.answer_details.defect_id,
        answer_text: this.answer_details.answer_text,
        answer_attachment: this.answer_details.answer_attachment,
        images: this.image,
        is_corrected: this.answer_details.is_corrected,
      };
      let input = {
        answers: [],
      };
      if (answer.defect_id && answer.answer_text) {
        input.answers.push(answer);
        let url = "/projects/inspection/" + this.$route.params.id;
        let response = await this.getHTTPPostResponse(
          url,
          input,
          "#save-answer",
          true
        );
        if (response) {
          this.getProject();
        }
      } else {
        this.displayError(
          "Please fill required details: Question No. " +
            this.que_num +
            "-" +
            this.que_name +
            "details"
        );
      }
    },
    // API Integration for Project Question Query Status
    async getProjectChangeQueryStatus(
      project_consultant_service_question_id,
      status
    ) {
      let input = {
        project_consultant_service_question_id,
        status,
      };
      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.getProject();
      }
    },
    getComments() {
      this.questionairy(this.que);
      this.popupActive = true;
      this.comments = this.answer_details.comments;
      // this.selected_question_index = qindex;
      // this.comments =
      //   this.filtered_questions[
      //     qindex
      //   ].project_consultant_service_question.comments;
    },
    // API Integration for Project Question Comments
    async addProjectQuestionComments() {
      let input = {
        // project_consultant_service_question_id:
        //   this.filtered_questions[this.selected_question_index]
        //     .project_consultant_service_question.id,
        project_consultant_service_question_id: this.answer_details.id,
        comment: this.comment,
      };
      let url = "/projects/comment/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.comment = "";
        this.popupActive = false;
        this.questionairy(this.que);
        this.getProject();
      }
    },
    // API Integration for getData
    async getProject() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        this.project = data.project;
        this.vessel_type_id = project.vessel_type_id;
        this.sub_type_id = project.vessel_sub_type_id;

        this.raw_consultants = project.consultants;
        let consultants = project.consultants;

        let filteredConsultants = [];
        for (let i = 0; i < consultants.length; i++) {
          let obj = { id: consultants[i].id, name: consultants[i].name };
          filteredConsultants.push(obj);
        }
        this.consultants = filteredConsultants;
        /**
        Our dear one consultant, why so many loops are here ???
         */
        if (this.consultants.length === 1) {
          this.consultant = this.consultants[0].id;
          this.selected_con = this.consultants[0].id;

          let service_req = consultants[0].project_consultant.services;
          let filteredServices = [];
          for (let j = 0; j < service_req.length; j++) {
            let obj = { id: service_req[j].id, name: service_req[j].name };
            filteredServices.push(obj);
          }
          this.services_drop = filteredServices;
        }

        // Map
        setTimeout(() => {
          let consultant_services_data = [];
          consultants.forEach((consultant) => {
            var services = consultant.project_consultant.services;
            let ser_id = [];
            services = services.forEach((serve) => {
              let squestions = serve.project_consultant_service.questions;
              squestions.forEach((que) => {});
              let obj = {
                service_name: serve.name,
                service_id: serve.id,
                service_question: squestions,
              };
              ser_id.push(obj);
            });
            consultant_services_data.push({
              consultant_id: consultant.id,
              consultant_name: consultant.name,
              services: this.service,
              work_instructions_text:
                consultant.project_consultant.work_instructions_text,
              work_instructions_attachment:
                consultant.project_consultant.work_instructions_attachment,
              status: consultant.project_consultant.status_name,
              service_ids: ser_id,
            });
          });
          this.consultant_services_array = consultant_services_data;
        }, 100);
        // Maping for images (for answers)

        project.consultants.forEach((eachCon) => {
          eachCon.project_consultant.services.forEach((eachSer) => {
            let dataQuestion = eachSer.project_consultant_service.questions.map(
              function (app) {
                if (
                  app.project_consultant_service_question.images != null &&
                  app.project_consultant_service_question.images.length != 0
                ) {
                  let images = [];
                  app.project_consultant_service_question.images.forEach(
                    (element) => {
                      if (element != null) {
                        images.push({
                          path: element,
                          s3_url: element,
                        });
                      }
                    }
                  );
                  app.project_consultant_service_question.images = images;
                } else {
                  app.project_consultant_service_question.images = [];
                }
                return app;
              }
            );
            this.questions = project.consultants;
          });
        });

        this.vesselTypeInfo = project.vessel_type;
        this.vesselSubTypeInfo = {
          ...project.vessel_sub_type,
          ship_image_url: project.ship_url,
        };
      }
      this.$vs.loading.close();
      this.isChanged = false;
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSection = [];
        let first_obj = { id: 0, name: "All Sections" };
        filteredSection.push(first_obj);
        for (var i = 0; i < sections.length; i++) {
          var section = sections[i];
          let obj = {
            id: sections[i].id,
            name: sections[i].id + ". " + sections[i].name,
          };
          filteredSection.push(obj);
          if (section.children.length) {
            for (var j = 0; j < section.children.length; j++) {
              var sub_type = section.children[j];
              filteredSection.push({
                id: sub_type.id,
                name: "----- " + sub_type.id + ". " + sub_type.name,
              });
            }
          }
        }
        // }
        this.filterSection = filteredSection;
      }
    },
    // API Integration for Designations
    async getDesignations() {
      let input = {
        name: this.designation,
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        let first_obj = { id: "", name: "All Designation" };
        filteredDesignations.push(first_obj);
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name,
          };
          filteredDesignations.push(obj);
        }
        this.filterDesignation = filteredDesignations;
      }
    },
    clearFilter() {
      this.designation = "";
      this.section = 0;
      this.query_status_filter = "";
      this.search = "";
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName(qindex) {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      // consultants.forEach(function (el) {
      //   if (el.id == con_target) {
      //     el.project_consultant.services.forEach(function (el) {
      //       if (el.id == ser_target) {
      //         el.project_consultant_service.questions[
      //           qindex
      //         ].project_consultant_service_question.answer_attachment = "";

      //         let id = "audio_control_exit" + qindex;
      //         document.getElementById(id).load();
      //       }
      //     });
      //   }
      // });
      qindex.answer_attachment = "";
    },
    async handleFiles(event, qindex) {
      // var files = event.target.files;
      // $("#audio_source" + index).attr("src", URL.createObjectURL(files[0]));
      // document.getElementById("audio_control" + index).load();
      let file = event.target.files[0];
      if (file.type !== "audio/mp3") {
        event.target.files[0].value = "";
      }
      // upload s3
      var input = new FormData();
      input.append("directory", "audio_file");
      input.append("attachment", file);
      let response = await this.getHTTPPostResponse(
        "/s3/upload",
        input,
        "",
        true
      );
      this.isChanged = true;
      this.answer_details.answer_attachment = response.data.url;
      // let consultants = this.raw_consultants;
      // let con_target = this.selected_con;
      // let ser_target = this.selected_ser;
      // console.log(consultants);
      // consultants.forEach(function (el) {
      //   if (el.id == con_target) {
      //     el.project_consultant.services.forEach(function (el) {
      //       if (el.id == ser_target) {
      //         el.project_consultant_service.questions[
      //           qindex
      //         ].project_consultant_service_question.answer_attachment =
      //           response.data.url;

      //         el.project_consultant_service.questions.forEach((el)=>{
      //           if(el.project_consultant_service_question.id == qindex){
      //             console.log("the selected audio",el.project_consultant_service_question.id)
      //             el.project_consultant_service_question.answer_attachment = response.data.url;
      //           }
      //         })
      //         let id = "audio_control" + qindex;
      //         document.getElementById(id).load();
      //       }
      //     });
      //   }
      // });
    },
    // Images Logic
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadImageSuccess(forData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      let flag = 1;
      if (
        fileImage.type === "image/png" ||
        fileImage.type === "image/jpeg" ||
        fileImage.type === "image/jpg"
      ) {
        flag = 1;
      } else {
        alert("Please upload image with extension .png ,.jpg, .jpeg");
        flag = 0;
        let consultants = this.raw_consultants;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      }
      if (fileImage.size > 10000000) {
        alert("Please upload under 10mb!");
        let consultants = this.raw_consultants;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      } else {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileImage);
        this.axios
          .post("s3/upload", input)
          .then((response) => {
            let data = response.data.data;
            let url = data.url;
            fileList[index].s3_url = data.url;
            this.isChanged = true;
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
            this.image.push(url);
          })
          .catch((e) => {
            this.showError(e);
          });
      }
    },
    beforeRemove(index, done, fileList) {
      this.image = this.answer_details.images;
      this.url = fileList[index].path;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done,
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage,
      });
    },
    removeImage() {
      let input = {
        url: this.url,
      };
      this.axios
        .post("s3/remove", input)
        .then((response) => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          }
          return "tttttt";
        })
        .catch((e) => {
          // this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
      this.image.splice(this.index, 1);
      // let newArray = this.image.filter((item) => item !== this.url);
      // console.log(newArray);
      // this.image = newArray;
    },
    async printQuestions(exp) {
      let input = {
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        is_guidance_required: 0,
        service_id: this.selected_ser,
      };
      if (exp) {
        input = Object.assign(input, {
          is_guidance_required: 1,
        });
      }
      this.axios
        .post("/projects/print-questions", input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          let name = "";
          if (exp) {
            name = this.project.name + "_with Guidance";
          } else {
            name = this.project.name + "_without Guidance";
          }
          this.exportPdfFile(data, name);
          this.export = 0;
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    // This function is called when we click on back button of page
    goBackConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: "Confirm",
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: "Are you sure you want leave without saving?",
        accept: this.cancle,
      });
    },
    detectChange() {
      this.isChanged = true;
    },
    // function to check all fields while preventing
    checkAllFields() {
      if (this.filtered_questions.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    // This function is called when we click on ok button of opened dialogue
    async cancle() {
      history.back();
    },
    // This function is called when we click on cancle button of opened dialogue or brwowser's reload of the page
    preventNav() {
      if (!this.checkAllFields()) {
        return;
      }
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    // This function is called when we click on back button of page and open new dialogue for confirmation
    goBack() {
      let flag = this.isChanged;
      const isInspectionDirty = this.$refs.inspectionImg.isFormDirty;

      if (flag || isInspectionDirty) {
        if (this.goBackConfirm()) {
          this.preventNav;
          return;
        }
      } else {
        history.back();
      }
    },
    // goBack() {
    //   history.back();
    // }
    async saveInspection() {
      const vessel_id = this.project.vessel_id;
      const projectId = this.project.id;
      const childData = this.$refs.inspectionImg.sections;
      const hasRedPin = childData.some(
        (section) =>
          (section.location && section.location.color === "red") ||
          section.subFolders.some(
            (subfolder) =>
              subfolder.location && subfolder.location.color === "red"
          )
      );
      if (hasRedPin) {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      } else {
        const foldersPayload = childData.map((v) => ({
          id: v.id || null,
          folder_name: v.folder_name,
          imageBlob: v.file || null,
          ga_plan_image: v.file ? null : v.ga_plan_image,
          location:
            v.location && v.location.color != "red"
              ? JSON.stringify({ x: v.location.x, y: v.location.y })
              : null,
          subFolders: v.subFolders.map((subfolder) => {
            const location =
              subfolder.location && subfolder.location.color != "red"
                ? subfolder.location
                : null;
            return {
              id: subfolder.id || null,
              folder_name: subfolder.folder_name,
              location: location
                ? JSON.stringify({ x: location.x, y: location.y })
                : null,
            };
          }),
        }));
        let formData = new FormData();
        formData.append("vessel_id", vessel_id);
        foldersPayload.forEach((folder, folder_index) => {
          if (folder.id) {
            formData.append(`folders[${folder_index}][id]`, folder.id);
          }
          formData.append(
            `folders[${folder_index}][folder_name]`,
            folder.folder_name
          );
          if (folder.imageBlob)
            formData.append(
              `folders[${folder_index}][imageBlob]`,
              folder.imageBlob
            );

          if (folder.ga_plan_image)
            formData.append(
              `folders[${folder_index}][ga_plan_image]`,
              folder.ga_plan_image
            );

          if (folder.location)
            formData.append(
              `folders[${folder_index}][location]`,
              folder.location
            );

          folder.subFolders.forEach((subfolder, subFolderIndex) => {
            if (subfolder.id) {
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][id]`,
                subfolder.id
              );
            }
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][folder_name]`,
              subfolder.folder_name
            );
            if (subfolder.location)
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][location]`,
                subfolder.location
              );
          });
        });
        this.$vs.loading();
        const response = await this.getHTTPPostResponse(
          `/projects/${projectId}/folder/subfolder/update`,
          formData
        );
        this.$vs.loading.close();
        this.$refs.inspectionImg.resetFormDirty();
        if (response.status == 200) {
          this.$vs.notify({
            title: "Success.",
            text: response.data.message,
            color: "success",
            position: "top-right",
          });
          this.getProjectFolderSubFolder();
        } else {
          this.showError(response);
        }
      }
    },
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}

.question-feather {
  vertical-align: middle;
}

.label-center {
  align-self: center !important;
}

a,
a:hover {
  color: #626262;
  text-decoration: none;
}

.audio {
  -webkit-text-stroke-width: thin;
}

[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: rgba(var(--vs-dark), 1);
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-size: inherit;
  font-weight: 500;
  outline: none;
  padding: 10px 40px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  vertical-align: middle;
}

[type="file"] + label:hover {
  -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-dark), 1);
  box-shadow: 0 8px 25px -8px rgba(var(--vs-dark), 1);
}

[type="file"] + label:hover {
  background-color: rgba(var(--vs-dark), 1);
}

[type="file"] + label.btn-1 {
  background-color: rgba(var(--vs-dark), 1);
  -webkit-transition: none;
  transition: none;
}

.service-border {
  border-bottom: 2px solid #f6f6f6;
}

.audio-file {
  align-items: flex-end;
}

.raise-question {
  position: absolute;
  right: 21px;
}

.comment-avatar {
  word-break: break-word;
}

.add-query {
  box-shadow: none !important;
  border: 1px solid #f1f1f1;
}

.submit-btn {
  text-align: center;
}

.header svg {
  width: 20px !important;
  height: 20px !important;
  color: rgba(var(--vs-dark), 1);
}

.external-link {
  color: rgba(var(--vs-danger), 1);
  /* float: left; */
}

.query-text .con-vs-chip {
  float: right !important;
}

.z-10 {
  z-index: 400 !important;
}

.card_position {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 47%;
  height: 109px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  float: left;
  background: #f3f3f3;
  border-radius: 10px;
  font-family: "Inter";
  font-style: normal;
  font-size: 17px;
}

.card_position2 {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 47%;
  height: 109px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  float: left;
  background: #f3f3f3;
  border-radius: 10px;
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif !important;
  font-style: normal;
}

.card_position:first-child {
  grid-column: span 2;
  grid-row: span 2;
}

.questionary_position {
  box-sizing: border-box;
  max-width: 350px;
  height: 618px;
  background: rgba(217, 217, 217, 0.16);
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 30px;
  border: 1px solid lightgrey;
  line-height: 25px;
  color: #253d5d;
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif !important;
  /* font-style: normal; */
  /* font-weight: 700; */
  font-size: 17px;
  overflow: scroll;
}

.safety_managemetnt {
  display: block;
}

.image_upload {
  /* margin-left: -41px;
  margin-right: 150px;
  justify-content: space-between;
  overflow: hidden;
  column-gap: 20px; */
}

.defeat_class {
  margin-left: 200px;
  /* margin-right: -350px; */
  width: 100%;
  display: flex;
  margin-top: -220px;
  justify-content: space-between;
  overflow: hidden;
}

.chat_raise_query {
  overflow: hidden;
}

.audio_section {
  display: flex;
}

.defect {
  margin-left: 750px;
  margin-top: -50px;
}

.save_button {
  /* position: absolute;
  margin-left: 327px;
  margin-top: 176px; */
  width: 100%;
}

.collapse_btn {
  margin-left: 300px;
}

.sub_section {
  margin-left: 20px;
}

.question_position {
  margin-left: 25px;
}

.card {
  font-size: larger;
}

.collapse_position {
  margin-left: 260px;
  margin-top: -25px;
}

.open {
}

summary {
  display: block;
}

summary::after {
  margin-left: 1ch;
  display: inline-block;
  transition: 0.2s;
  content: "\203A";
  /* chevron */
}

details[open] summary::after {
  transform: rotate(90deg);
}

.text_click:focus {
  background-color: #dbdbdb;
}

.questionair_card_position {
  margin-top: 30px;
}

.text_header {
  color: #253d5d;
}

.chat_section {
  display: block;
  margin-top: -631px;
  margin-left: 450px;
}

.text_header_question {
  font-size: 20px;
}

.search {
  width: 185px;
  border-radius: 5px;
}

.new {
  /* margin-top: -241px;
  margin-right: -155px;
  margin-left: 193px; */
}

.status {
  position: absolute;
  top: -77px;
}

.z-index-bottom {
  z-index: 0;
}

.z-index-middle {
  z-index: 4;
}

.z-index-top {
  z-index: 9;
}

.margin-minus {
  margin-top: -25px !important;
}

.right-btns {
  order: 2;
}

.clear-btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #253d5d;
  background: #f1f1f1;
  float: right;
  font-size: 12px;
  display: flex;
  position: absolute;
  margin-top: -30px;
  margin-left: 170px;
  height: max-content;
  width: fit-content;
  transition-duration: 500ms;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.clear-btn::after {
  display: none;
}
</style>
